import React, {useMemo} from "react"
import {useTranslation} from "react-i18next"
import {makeStyles} from "@material-ui/core/styles"
import {grey, orange} from "@material-ui/core/colors"
import {List, ListItem, ListItemText, ListItemAvatar, Avatar} from "@material-ui/core"
import clsx from "clsx"
import {useStore, useDispatch} from "../Store"
import "../i18n"
import {isAmOne} from "../common"
import CancelIcon from "@material-ui/icons/Cancel"
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined"

const useStyles = makeStyles((theme) => ({
  list: {
    paddingTop: 0,
  },
  listItem: {
    paddingLeft: 12,
    cursor: `pointer`,
    "&:hover": {
      backgroundColor: orange[500],
      color: grey[50],
    },
  },
  menuClose: {
    [theme.breakpoints.up(`sm`)]: {
      display: `none`,
    },
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: `white`,
  },
  square: {
    color: `white`,
    width: `40`,
  },
  label: {
    marginLeft: 24,
  },
}))

export default function NavContentEx({id, sidebar, setOpen, setCollapsed}) {
  const {
    store: {page, locale, themeColor},
  } = useStore()
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const classes = useStyles()

  const onClose = () => {
    if (!(sidebar[id]?.open ?? null)) return null
    const collapsed = sidebar[id]?.collapsed ?? null
    if (collapsed) setCollapsed(id, true)
    setOpen(id, false)
  }

  const switchPerspective = (next) => () => {
    onClose()
    if (next !== page) {
      dispatch({type: `PAGE`, page: next})
    }
  }

  const menuItems = [
    {page: `MENU_CLOSE`, text: `menuClose`, icon: `code`, image: `home`},
    //{page: `HOME`, text: `home`, icon: `fullscreen`, image: `home`},      // 「トレンドランキング」と「類似チャート」に画面分割
    {page: `TREND_RANKING`, text: `pageTrendRanking`, icon: `fullscreen`, image: `trendranking`},
    {page: `SIMILAR_CHART`, text: `pageSimilarChart`, icon: `fullscreen`, image: `similarchart`},
    {page: `SETTING`, text: `settings`, icon: `settings`, image: `settings`},
  ]
  if (!isAmOne()) menuItems.push({page: `DASHBOARD`, text: `dashboard`, icon: `apps`, image: `dashboard`})

  const colorName = themeColor.charAt(0).toUpperCase() + themeColor.slice(1)
  const menuList = useMemo(
    () =>
      menuItems.map((item) => {
        const icon =
          item.page === `MENU_CLOSE` ? (
            <Avatar>{themeColor === `dark` ? <CancelOutlinedIcon /> : <CancelIcon />}</Avatar>
          ) : (
            <Avatar variant={`square`} className={classes.square} src={`images/sideMenuIcon/${item.image}${colorName}.svg`} />
          )
        const className = item.page === `MENU_CLOSE` ? classes.menuClose : ``
        return (
          <ListItem
            key={item.page}
            onClick={item.page === `MENU_CLOSE` ? () => onClose() : switchPerspective(item.page)}
            className={clsx(classes.listItem, item.page === page ? classes.active : ``, className)}
          >
            <ListItemAvatar>{icon}</ListItemAvatar>
            <ListItemText primary={t(item.text) /* i18next-extract-disable-line */} primaryTypographyProps={{noWrap: true}} />
          </ListItem>
        )
      }),
    [menuItems, classes, page, locale, themeColor],
  )
  return <List className={classes.list}>{menuList}</List>
}
